import type { JSX } from '@builder.io/qwik';
import { component$, useContext } from '@builder.io/qwik';
import ContentBuilder from '~/components/Layout/Builders/ContentBuilder';
import { ArticleContext } from '~/contexts/ArticleContext';
import { AppDataContext } from '~/contexts/AppDataContext';
import { maybeGetSlide } from '~/utilities/maybeGetSlide';
import type { ArticleInterface } from '~/types/AppData/PageContent/ArticleInterface';

export default component$((): JSX.Element => {
  const { payloadToSSR, appState } = useContext(AppDataContext);
  const article = useContext(ArticleContext);
  const { experiments } = payloadToSSR;

  if (!article) return <></>;

  const slideshow = payloadToSSR.pageContent.slideshow ?? article.slideshow;

  return (
    <div class='article-content'>
      <ContentBuilder
        items={maybeGetSlide(
          article as ArticleInterface,
          slideshow,
          appState.currentSlide,
          experiments
        )}
      />
    </div>
  );
});
